// ===================================================================
// Time & Labor — Module Layout with nav bar
// FEMA Force Account Labor Tracking
// ===================================================================

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconLayoutDashboard, IconClock, IconUsers,
  IconFileSpreadsheet, IconChecklist,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import { useRoleStore } from '../../store/roleStore';
import type { NavItem } from '../../types/nav';
import ModuleNav from '../../components/layout/ModuleNav';
import MyTimePortal from './MyTimePortal';
import PageHeader from '../../components/ui/PageHeader';

const TEAL = '#0D9488';

// Roles that get the personal portal instead of admin view
const PORTAL_SLUGS = ['timelabor_only'];

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard',  path: '/timelabor',            icon: IconLayoutDashboard, exact: true },
  { label: 'Time Entry', path: '/timelabor/timeentry',   icon: IconClock },
  { label: 'Employees',  path: '/timelabor/employees',   icon: IconUsers },
  { label: 'Review',     path: '/timelabor/review',      icon: IconChecklist, minLevel: 'admin' },
  { label: 'Summaries',  path: '/timelabor/summaries',   icon: IconFileSpreadsheet, minLevel: 'admin' },
  { label: 'FF-104',     path: '/timelabor/ff104',        icon: IconFileSpreadsheet, minLevel: 'admin' },
];

export default function TimeLaborLayout() {
  const { pathname } = useLocation();
  const effectiveRole = useRoleStore(s => s.demoRoleOverride ?? s.myRole);
  const slug = effectiveRole?.roleSlug ?? '';
  const visibleItems = useFilteredNav('timelabor', NAV_ITEMS);

  // Time & Labor only users get the personal portal
  if (PORTAL_SLUGS.includes(slug)) {
    return (
      <div style={{ padding: '24px' }}>
        <MyTimePortal />
      </div>
    );
  }

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      <PageHeader
        breadcrumbs={[{ label: 'Recover' }, { label: 'Time & Labor' }]}
        title="Time & Labor"
        subtitle="Force account labor tracking and FEMA FF-104 reporting"
      />
      <ModuleNav items={visibleItems} accentColor={TEAL} />
      <Outlet />
    </div>
  );
}
